module.exports = __webpack_public_path__ + "img/5.68b8b8dc.png";